import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "56",
  height: "56",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M56 40c0 8.837-7.163 16-16 16H16C7.163 56 0 48.837 0 40V16C0 7.163 7.163 0 16 0h24c8.837 0 16 7.163 16 16zm-18-9.893C38 23.421 32.58 18 25.893 18H18v15.135h16.973A3.03 3.03 0 0 0 38 30.107m0 6.474a1.42 1.42 0 0 0-1.419-1.419H19.42a1.42 1.42 0 0 0 0 2.838H36.58c.784 0 1.419-.635 1.419-1.419m-13.541-9.178a1 1 0 0 1-1 1h-1.81a1 1 0 0 1-1-1V23.73a1 1 0 0 1 1-1h1.81a1 1 0 0 1 1 1zm8.57.667c0 .184-.15.333-.334.333h-6.362a.417.417 0 0 1-.417-.416v-4.842c0-.23.187-.416.417-.416h1.355a5.34 5.34 0 0 1 5.341 5.341"
    }, null, -1)
  ]))]))
}
export default { render: render }